import React from "react";

import ButtonSolid from "../Button/ButtonSolid";
// import ButtonGhost from "../Button/ButtonGhost";

const ContactButtons = ({ buttons, phonenumber }) => {
  const ButtonGroup = buttons || "div";

  return (
    <ButtonGroup>
      <div className="grid grid-cols-10">
        <div className="col-span-3 col-start-1 block">
          <ButtonSolid className="" modal="modal-contact" text="Contact" />
        </div>
        {/* <div className="col-span-3 col-start-5 block md:col-start-4">
          <ButtonGhost href="tel:(619) 233-8382" text={"(619) 233-8382"} />
        </div> */}
      </div>
    </ButtonGroup>
  );
};

export default ContactButtons;
